export const houseBlocksPositions = {
  walls: {
    texture: "/house/bricks.png",
    positions: [
      // wall back
      [1, 0, 0],
      [1, 1, 0],
      [1, 2, 0],
      [1, 3, 0],
      [1, 4, 0],
      [2, 0, 0],
      [2, 1, 0],
      [2, 2, 0],
      [2, 3, 0],
      [2, 4, 0],
      [3, 0, 0],
      [3, 1, 0],
      [3, 2, 0],
      [3, 3, 0],
      [3, 4, 0],
      [4, 0, 0],
      [4, 1, 0],
      [4, 2, 0],
      [4, 3, 0],
      [4, 4, 0],
      [5, 0, 0],
      [5, 1, 0],
      [5, 2, 0],
      [5, 3, 0],
      [5, 4, 0],

      [1, 5, 0],
      [2, 5, 0],
      [3, 5, 0],
      [4, 5, 0],
      [5, 5, 0],
      [2, 6, 0],
      [3, 6, 0],
      [4, 6, 0],
      [3, 7, 0],

      // wall front
      [1, 0, 6],
      [1, 1, 6],
      [1, 2, 6],
      // [1, 3, 6],
      // [1, 4, 6],
      [2, 0, 6],
      [2, 1, 6],
      [2, 2, 6],
      // [2, 3, 6],
      // [2, 4, 6],
      // [3, 0, 6],
      // [3, 1, 6],
      [3, 2, 6],
      [3, 3, 6],
      [3, 4, 6],
      [4, 0, 6],
      [4, 1, 6],
      [4, 2, 6],
      // [4, 3, 6],
      // [4, 4, 6],
      [5, 0, 6],
      [5, 1, 6],
      [5, 2, 6],
      // [5, 3, 6],
      // [5, 4, 6],

      [1, 5, 6],
      [2, 5, 6],
      [3, 5, 6],
      [4, 5, 6],
      [5, 5, 6],
      [2, 6, 6],
      [3, 6, 6],
      [4, 6, 6],
      [3, 7, 6],

      // wall left
      [0, 0, 1],
      [0, 1, 1],
      [0, 2, 1],
      [0, 3, 1],
      [0, 4, 1],
      [0, 0, 2],
      [0, 1, 2],
      [0, 2, 2],
      [0, 3, 2],
      [0, 4, 2],
      [0, 0, 3],
      [0, 1, 3],
      [0, 2, 3],
      [0, 3, 3],
      [0, 4, 3],
      [0, 0, 4],
      [0, 1, 4],
      [0, 2, 4],
      [0, 3, 4],
      [0, 4, 4],
      [0, 0, 5],
      [0, 1, 5],
      [0, 2, 5],
      [0, 3, 5],
      [0, 4, 5],

      // wall right
      [6, 0, 1],
      [6, 1, 1],
      [6, 2, 1],
      [6, 3, 1],
      [6, 4, 1],
      [6, 0, 2],
      [6, 1, 2],
      [6, 2, 2],
      [6, 3, 2],
      [6, 4, 2],
      [6, 0, 3],
      [6, 1, 3],
      [6, 2, 3],
      [6, 3, 3],
      [6, 4, 3],
      [6, 0, 4],
      [6, 1, 4],
      [6, 2, 4],
      [6, 3, 4],
      [6, 4, 4],
      [6, 0, 5],
      [6, 1, 5],
      [6, 2, 5],
      [6, 3, 5],
      [6, 4, 5],
    ],
  },

  chimney: {
    texture: "/house/bricks.png",
    positions: [
      [5, 7, 2],
      [5, 8, 2],
    ],
  },

  pilars: {
    texture: "/house/wood.jpg",
    positions: [
      [0, 0, 0],
      [0, 1, 0],
      [0, 2, 0],
      [0, 3, 0],
      [0, 4, 0],

      [0, 0, 6],
      [0, 1, 6],
      [0, 2, 6],
      [0, 3, 6],
      [0, 4, 6],

      [6, 0, 0],
      [6, 1, 0],
      [6, 2, 0],
      [6, 3, 0],
      [6, 4, 0],

      [6, 0, 6],
      [6, 1, 6],
      [6, 2, 6],
      [6, 3, 6],
      [6, 4, 6],
    ],
  },

  roof: {
    texture: "/house/snow.jpg",
    positions: [
      [0, 5, 0],
      [0, 5, 1],
      [0, 5, 2],
      [0, 5, 3],
      [0, 5, 4],
      [0, 5, 5],
      [0, 5, 6],

      [1, 6, 0],
      [1, 6, 1],
      [1, 6, 2],
      [1, 6, 3],
      [1, 6, 4],
      [1, 6, 5],
      [1, 6, 6],

      [2, 7, 0],
      [2, 7, 1],
      [2, 7, 2],
      [2, 7, 3],
      [2, 7, 4],
      [2, 7, 5],
      [2, 7, 6],

      [3, 8, 0],
      [3, 8, 1],
      [3, 8, 2],
      [3, 8, 3],
      [3, 8, 4],
      [3, 8, 5],
      [3, 8, 6],

      [4, 7, 0],
      [4, 7, 1],
      [4, 7, 2],
      [4, 7, 3],
      [4, 7, 4],
      [4, 7, 5],
      [4, 7, 6],

      [5, 6, 0],
      [5, 6, 1],
      [5, 6, 2],
      [5, 6, 3],
      [5, 6, 4],
      [5, 6, 5],
      [5, 6, 6],

      [6, 5, 0],
      [6, 5, 1],
      [6, 5, 2],
      [6, 5, 3],
      [6, 5, 4],
      [6, 5, 5],
      [6, 5, 6],
    ],
  },

  doorTop: {
    texture: "/house/dark_oak_door_top.png",
    positions: [[3, 1, 6]],
  },

  doorBottom: {
    texture: "/house/dark_oak_door_bottom.png",
    positions: [[3, 0, 6]],
  },

  windows: {
    texture: "/house/bamboo_trapdoor.png",
    positions: [
      [1, 3, 6],
      [1, 4, 6],
      [2, 3, 6],
      [2, 4, 6],
      [4, 3, 6],
      [4, 4, 6],
      [5, 3, 6],
      [5, 4, 6],
    ],
  },

  grinch: {
    texture: "/grinch/grinch-head.png",
    positions: [[5, 9, 2]],
  },
};
